"use client";
import * as React from "react";
const SvgCloseRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M15.65.37a1.2 1.2 0 0 0-1.72 0L8 6.29 2.07.36a1.2 1.2 0 0 0-1.71 0 1.2 1.2 0 0 0 0 1.7L6.28 8 .36 13.93a1.2 1.2 0 0 0 0 1.71 1.2 1.2 0 0 0 1.7 0L8 9.72l5.93 5.94a1.2 1.2 0 0 0 1.72 0 1.2 1.2 0 0 0 0-1.72L9.7 8l5.94-5.93a1.2 1.2 0 0 0 0-1.7" }));
export {
  SvgCloseRound as default
};
